import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import CagnottePage from './pages/CagnottePage';
import DashboardPage from './pages/DashboardPage';
import PaymentCallbackPage from './pages/PaymentCallbackPage';
import AdminLoginPage from './pages/AdminLoginPage';
import AdminDashboardPage from './pages/AdminDashboardPage';
import RGPDPage from './pages/RGPDPage';
import TarifsPage from './pages/TarifsPage';
import CGUPage from './pages/CGUPage';
import ContactPage from './pages/ContactPage';
import RGPDBanner from './components/RGPDBanner';
import RGPDChatbot from './components/RGPDChatbot';
import InstallPrompt from './components/InstallPrompt';
import { Toaster } from './components/ui/toaster';
import ErrorBoundary from './components/ErrorBoundary';
import { AuthProvider } from './context/AuthContext';

// The RGPD banner/chatbot must not overlay the admin console (it has its own layout).
function GlobalRGPDWidgets() {
  const { pathname } = useLocation();
  if (pathname.startsWith('/admin')) return null;
  return (
    <>
      <RGPDBanner />
      <RGPDChatbot />
      <InstallPrompt />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <ErrorBoundary>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/cagnotte/:id" element={<CagnottePage />} />
              <Route path="/dashboard" element={<DashboardPage />} />
              <Route path="/mes-cagnottes" element={<DashboardPage />} />
              <Route path="/paiement/retour" element={<PaymentCallbackPage />} />
              <Route path="/rgpd" element={<RGPDPage />} />
              <Route path="/tarifs" element={<TarifsPage />} />
              <Route path="/cgu" element={<CGUPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/admin/login" element={<AdminLoginPage />} />
              <Route path="/admin" element={<AdminDashboardPage />} />
            </Routes>
            <GlobalRGPDWidgets />
          </ErrorBoundary>
        </BrowserRouter>
        <Toaster />
      </AuthProvider>
    </div>
  );
}

export default App;
